module.exports = __webpack_public_path__ + "static/media/spinner.f873cd37.gif";